<template>
  <b-container fluid>
    <div v-if="loading" style="margin-top:90px;" class="text-center">
      <b-spinner label="Loading..."></b-spinner>
    </div>
    <div v-if="entries.length < 1 && !loading" style="margin-top:90px;" class="text-center">
      <span v-if="browsetype == 'assignments'">
        {{$t('NO_ASSIGNMENTS')}}
      </span>
      <span v-else>
        {{$t('NO_ENTRIES')}}
      </span>
      
    </div>
    <b-row style="margin-top:90px;">
      <browse-entry
        v-for="(entry,index) in entries"
        v-bind:key="entry.ID"
        v-bind:ID="entry.ID"
        v-bind:Thumbnail="entry.Thumbnail"
        v-bind:FileURL="entry.Location"
        v-bind:ContentType="entry.ContentType"
        v-bind:Title="entry.Title"
        v-bind:ComponentName="entry.Component"
        v-bind:IsAssignment="entry.IsAssignment"
        v-bind:BaseContent="entry.BaseContent"
        v-bind:StartPoint="entry.StartPoint"
        v-bind:EndPoint="entry.EndPoint"
        v-bind:OnLanding="false"
        v-bind:index = "index"
      />
    </b-row>
  </b-container>
</template>
<script>
import BrowseEntry from "./BrowseEntry.vue";
import { ajaxGet } from "../ajax";
import {apiUrl } from "../main";

export default {
  components: {
    BrowseEntry
  },
  props: ["browsetype", "token", "SearchString"],
  data: function() {
    var retData = {
      entries: [],
      loading: true
    };

    return retData;
  },
  beforeRouteUpdate: function(to, from, next) {
    //Ajax loading also used to happen here -note-

    next();
  },
  mounted: function() {
    this.entries = [];
    this.loading = true;
    window.document.title = (this.$router.history.current.params.browsetype.toUpperCase());

    var toType = this.browsetype;

    if (toType.endsWith("s") || toType.endsWith("S"))
      toType = toType.substring(0, toType.length - 1);

    if (toType.endsWith("s") || toType.endsWith("S"))
      toType = toType.substring(0, toType.length - 1);
        
    let path =
      apiUrl() + "/content?ContentType=" +
      toType.toUpperCase();

    if(toType == "featured"){
      path = apiUrl() + "/content/featuredcontent";
    }
       
    if (this.$route.query.SearchString) {
      path =
        apiUrl() +
          "/search?SearchString=" +
        this.$route.query.SearchString;
    }

    var browseComp = this;

    setTimeout(function() {
      ajaxGet(
        path,
        browseComp.dataSuccessLoad,
        browseComp.dataError,
        browseComp.token
      );
    }, 50);
  },
  methods: {
    dataSuccessLoad: function(res) {
      this.entries = res;
      this.loading = false;
    },
    dataError: function(status = 0) {
      if(status == 401) {
        this.$emit('logout');
        this.$router.push('/');
      }
    }
  }
};
</script>